import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary gap-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Reports", -1)
const _hoisted_3 = { class: "d-flex gap-10 w-100 flex-md-row flex-column" }
const _hoisted_4 = { class: "bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-lg-wrap flex-nowrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start gap-10 flex-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Contributions & Work History Report ")
], -1)
const _hoisted_6 = { class: "bordered-card bordered-card_secondary justify-content-between pdt-25 pdb-25 gap-25 flex-lg-wrap flex-nowrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start gap-10 flex-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Create your own report ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: "btn btn-primary border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1",
          to: { name: 'local.contribution-history' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Work History Report ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_router_link, {
          class: "btn btn-primary border-radius-8 pdl-30 pdr-30 w-sm-100 w-fit flex-1",
          to: { name: 'local.create-report' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Create Report ")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}